import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { BaseForm as Form } from 'component/base'
import queryString from 'query-string'

export const Chiku = props => {
  const { busho_id_list, is_member, ...other } = props
  const url = useMemo(
    () => (is_member ? '/api/member/master/chiku' : '/api/staff/master/chiku'),
    []
  )
  return (
    <>
      {busho_id_list ? (
        <ListBase
          url={`${url}?${queryString.stringify({ busho_id_list })}`}
          {...other}
        />
      ) : (
          <Form.Dropdown.WithAPI
            url={url}
            keyName='id'
            valueName='id'
            textName='chiku_name'
            sort={['chiku_cd']}
            {...other}
          />
        )}
    </>
  )
}

Chiku.propTypes = {
  name: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  value: PropTypes.any,
  is_member: PropTypes.bool,
}

Chiku.defaultProps = {
  name: 'chiku',
  label: '地区',
  value: undefined,
  is_member: false,
}

const ListBase = props => {
  const { url, ...other } = props

  return (
    <Form.Dropdown.WithAPI
      url={url}
      keyName='id'
      valueName='id'
      textName='chiku_name'
      sort={['chiku_cd']}
      {...other}
    />
  )
}
